import { AppRadioGroup, AppRadioGroupProps, RadioGroupValue } from 'components/core/AppRadioGroup/AppRadioGroup';

import { AlluraFormikErrorMessage } from 'components/formik/core/AlluraErrorMessage/AlluraFormikErrorMessage';
import { useField } from 'formik';

interface Props {
  name: string;
  variant?: string;
  isPaddingNarrow?: boolean;
  hasTitle?: boolean;
  title?: string;
  sm?: number;
  md?: number;
  lg?: number;
}

export const FormikAppRadioGroup = ({
  name,
  buttons,
  variant,
  isPaddingNarrow = false,
  hasTitle = true,
  title,
  sm,
  md,
  lg,
  disabled = false,
  ...rest
}: Props & Omit<AppRadioGroupProps, 'value' | 'setValue'>) => {
  const [field, , helpers] = useField<RadioGroupValue>(name);

  const setValue = (val: RadioGroupValue) => {
    helpers.setValue(val);
  };

  return (
    <>
      <AppRadioGroup
        name={name}
        value={field.value}
        setValue={setValue}
        buttons={buttons}
        title={hasTitle ? title : undefined}
        sm={sm}
        md={md}
        lg={lg}
        onBlur={field.onBlur}
        variant={variant}
        isPaddingNarrow={isPaddingNarrow}
        disabled={disabled}
        {...rest}
      />
      <AlluraFormikErrorMessage fieldName={field.name} />
    </>
  );
};
